(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItLatestUsage', ["path", "defaultListConverter", "securityEventsConverters", "securityEventsDao", "objectTypeDao", "timeResolutions", "tablePaginationHelper", function (path, defaultListConverter, securityEventsConverters, securityEventsDao, objectTypeDao, timeResolutions, tablePaginationHelper) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/latest-usage').template('latest-usage'),
            scope: {
                saasList: '=',
                resolution: '=',
                eventStates: '='
            },
            link: function ($scope) {
                $scope.options = {
                    columns: [
                        {
                            id: 'id',
                            hidden: true,
                            primary: true
                        },
                        {
                            id: 'create_time',
                            text: 'Time',
                            converter: 'doubleLineDate'
                        },
                        {
                            id: 'saas',
                            text: 'SaaS',
                            converter: 'eventSaas',
                            dataClass: 'saas-icon'
                        },
                        {
                            id: 'description_short',
                            text: 'Event Description',
                            class: 'wide-column',
                            dataClass: 'wide-column',
                            converter: 'descriptionConverter'
                        },
                        {
                            id: '_resolved',
                            hidden: true
                        },
                        {
                            id: 'entity_id',
                            hidden: true
                        },
                        {
                            id: 'entity_type',
                            hidden: true
                        }
                    ],
                    options: {
                        defaultOrdering: {
                            columnName: 'create_time',
                            order: 'desc'
                        },
                        checkboxes: false,
                        autoUpdate: 30000
                    }
                };
                $scope.tableOptions = {
                    disableTop: true,
                    orderDisplayMode: 'highlight-column',
                    asDivs: true,
                    infinite: true,
                    showWorkingIndicator: true,
                    workingIndicatorDisableGui: false,
                    pagesAround: 2,
                    pagination: {
                        pageSize: 20,
                        ordering: {}
                    },
                    dropdownHeader: true
                };
                $scope.tableModel = $.extend({ data: [] }, $scope.options);
                $scope.init = function () {
                    if ($scope.tableHelper) {
                        $scope.tableHelper.destroy();
                    }
                    $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                        var result = securityEventsDao.list().preFetch(objectTypeDao.entities(), 'objectTypes').params({
                            filterEnum_saas: _($scope.saasList).map(function (saas) {
                                return saas.name;
                            }).join(','),
                            filterEnum_type: 'shadow_it',
                            resolve: true
                        });
                        if (timeResolutions.get($scope.resolution)) {
                            result.params({
                                'afterColumn': 'create_time',
                                'afterStep': $scope.resolution,
                                'afterFromNow': true,
                                'afterMax': 1
                            });
                        }
                        if ($scope.eventStates) {
                            result.params({ filterEnum_current_state: $scope.eventStates.join(',') });
                        }
                        return result.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                            return {
                                columns: _($scope.options.columns).map(function (column) {
                                    if (column.converter == 'descriptionConverter') {
                                        column.converterArgs = column.converterArgs || {};
                                        column.converterArgs.objectTypes = preFetches.objectTypes;
                                    }
                                    return column;
                                }),
                                converters: securityEventsConverters
                            };
                        });
                    }, function (tableModel) {
                        if (tableModel) {
                            $scope.tableModel = tableModel;
                        }
                        $scope.totalEvents = $scope.tableHelper.getTotal();
                    });
                };
                $scope.$watchGroup([
                    'resolution',
                    'saasList',
                    'eventStates'
                ], function () {
                    $scope.init();
                });
            }
        };
    }]);
}());